import { render, staticRenderFns } from "./ConsultantOrderSummary.vue?vue&type=template&id=57a5c4a4&scoped=true"
import script from "./ConsultantOrderSummary.vue?vue&type=script&lang=js"
export * from "./ConsultantOrderSummary.vue?vue&type=script&lang=js"
import style0 from "./ConsultantOrderSummary.vue?vue&type=style&index=0&id=57a5c4a4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a5c4a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57a5c4a4')) {
      api.createRecord('57a5c4a4', component.options)
    } else {
      api.reload('57a5c4a4', component.options)
    }
    module.hot.accept("./ConsultantOrderSummary.vue?vue&type=template&id=57a5c4a4&scoped=true", function () {
      api.rerender('57a5c4a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/ConsultantOrderSummary.vue"
export default component.exports